export const defaultTranslations = {
    'en-gb': {
        inputPlaceholder: 'What are you looking for?',
        live: 'Live',
        noResultsFoundTitle: 'No results found',
        noResultsFoundDescription: "Unfortunately we weren't able to find what you were looking for",
        raceGoing: 'Going',
        searchTitle: 'Search',
        sectionPreviousSearchesTitle: 'Previous Searches',
        sectionPopularSearchesTitle: 'Popular Searches',
        sectionCasinoGamesTitle: 'Gaming',
        sectionEventsTitle: 'Events',
        sectionHelpAnswersTitle: 'Help',
        sectionLeaguesTitle: 'Leagues',
        sectionMatchesTitle: 'Matches',
        sectionPromotionTitle: 'Promotions',
        sectionRacesTitle: 'Races',
        sectionSelectionsTitle: 'Selections',
        sectionSportsTitle: 'Sports',
        sectionTournamentsTitle: 'Tournaments',
        showAll: 'Show All',
        sportResultHighlight: 'Betting at William Hill',
    },
    'es-es': {
        inputPlaceholder: '¿Qué estás buscando?',
        live: 'En Directo',
        noResultsFoundTitle: 'No se han encontrado resultados',
        noResultsFoundDescription: 'No hemos podido encontrar lo que estabas buscando',
        raceGoing: 'Paso',
        searchTitle: 'Buscar',
        sectionPreviousSearchesTitle: 'Búsquedas recientes',
        sectionPopularSearchesTitle: 'Búsquedas populares',
        sectionCasinoGamesTitle: 'Juegos de Casino',
        sectionEventsTitle: 'Eventos',
        sectionHelpAnswersTitle: 'Ayuda',
        sectionLeaguesTitle: 'Ligas',
        sectionMatchesTitle: 'Partidos',
        sectionPromotionTitle: 'Promociones',
        sectionRacesTitle: 'Carreras de caballos',
        sectionSelectionsTitle: 'Selecciones',
        sectionSportsTitle: 'Deportes',
        sectionTournamentsTitle: 'Torneos',
        showAll: 'Mostrar más',
        sportResultHighlight: 'William Hill Apuestas Deportivas',
    },
};
//# sourceMappingURL=translations.js.map